module.exports = __webpack_public_path__ + "static/media/logo.1bef2a44.png";